import React, { Component } from 'react';
import {Header} from './header.js';
import {Footer} from './footer.js';
import './registration.css';
import './registration-old.css';

let faqReg = [
];

export class Registration extends Component {
  constructor (props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      firstname: '',
      lastname: '',
      username: '',
      company: '',
      department: '',
      email: '',
      password: '',
      password_verification: '',
      street: '',
      street_number: '',
      additional_address: '',
      zip_code: '',
      city: '',
      country: 'Deutschland',
      non_commercial_confirm: false,
      error: {
        required_fields: []
      }
    };
  }

  errorMessages = {
    password_mismatch: "Die angegebenen Passwörter stimmen nicht überein",
    registration_failed: "Ein Fehler ist aufgetreten. Verwenden Sie keine Nutzernamen und E-Mail Adressen mehrfach.",
    username_invalid: "Benutzername ungültig",
    error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  };

  onSubmit(event) {
    event.preventDefault();
    let fd = new FormData();
    fd.append("firstname", this.state.firstname);
    fd.append("lastname", this.state.lastname);
    fd.append("username", this.state.username);
    fd.append("email", this.state.email);
    fd.append("password", this.state.password);
    fd.append("password_verification", this.state.password_verification);
    fd.append("role", this.props.match.params.role === 'non_commercial' ? 3 : 2);
    fd.append("company", this.state.company);
    fd.append("department", this.state.department);
    fd.append("street", this.state.street);
    fd.append("street_number", this.state.street_number);
    fd.append("additional_address", this.state.additional_address);
    fd.append("zip_code", this.state.zip_code);
    fd.append("city", this.state.city);
    fd.append("country", this.state.country);
    fd.append("non_commercial_confirm", this.state.non_commercial_confirm);

    if (true) {
      fetch('/api/register', {
        method: 'POST',
        body: fd
      })
        .then(resp => {
          resp.json().then(json => {
            if (resp.status >= 400) {
              this.setState({
                error: json
              });
              window.confirm('Ein Fehler ist aufgetreten. Nutzername oder E-Mail Adresse sind bereits vergeben.');
            }
            else {
              this.props.history.replace("/activation-after-register");
            }
          });
        })
        .catch(error => { console.log("Error: ", error); window.confirm('Ein Fehler ist aufgetreten. Nutzername oder E-Mail Adresse sind bereits vergeben.'); })
    }
  }

  render() {
    return (
      <div className="Landing" id="contentId">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
            <div className="contentHeaderText">
              Registrierung als {this.props.match.params.role === 'non_commercial' ? 'Privatperson oder Mitarbeiter im Gesundheitswesen' : 'Herstellende'}
            </div>

            <div className="regTileDown marginTop30">
              <div>
                <div className="regHeaderTexts">
                  Allgemeine Angaben
                </div>
                <input placeholder="Vorname"
                       onChange = { (event) => this.setState({firstname: event.target.value.trim()}) }
                       className="regInput "></input>
                <input placeholder="Name"
                       onChange = { (event) => this.setState({lastname: event.target.value.trim()}) }
                       className="regInput"></input>
                <input placeholder="Email"
                       onChange = { (event) => this.setState({email: event.target.value.trim()}) }
                       className="regInput"></input>
                <input placeholder="Nutzername - wird zur Anzeige in den Foren verwendet"
                       onChange = { (event) => this.setState({username: event.target.value.trim()}) }
                       className="regInput"></input>
                <input placeholder="Passwort" type="password"
                       onChange = { (event) => this.setState({password: event.target.value}) }
                       className="regInput"></input>
                <input placeholder="Passwort Bestätigung" type="password"
                       onChange = { (event) => this.setState({password_verification: event.target.value}) }
                       className="regInput"></input>
              </div>
              <div className="marginTop30">
                <div className="regHeaderTexts">
                  Unternehmen (Freiwillige Angaben)
                </div>
                <input placeholder="Firma"
                       onChange = { (event) => this.setState({company: event.target.value}) }
                       className="regInput "></input>
                <input placeholder="Abteilung"
                       onChange = { (event) => this.setState({department: event.target.value}) }
                       className="regInput"></input>
              </div>
              <div className="marginTop30">
                <div className="regHeaderTexts">
                  Adresse (Freiwillige Angaben)
                </div>
                <input placeholder="Strasse"
                       onChange = { (event) => this.setState({street: event.target.value}) }
                       className="regInput "></input>
                <input placeholder="Hausnummer"
                       onChange = { (event) => this.setState({street_number: event.target.value}) }
                       className="regInput"></input>
                <input placeholder="Adresszusatz"
                       onChange = { (event) => this.setState({additional_address: event.target.value}) }
                       className="regInput"></input>
                <input placeholder="PLZ"
                       onChange = { (event) => this.setState({zip_code: event.target.value}) }
                       className="regInput"></input>
                <input placeholder="Ort"
                       onChange = { (event) => this.setState({city: event.target.value}) }
                       className="regInput"></input>
              </div>
              {/* <select name="country" value={this.state.country} onChange={this.handleInputChange}> */}
              <div>
                <div className="regHeaderTextSmall">Land</div>
                <select onChange = { (event) => this.setState({country: event.target.value}) }
                        className="styledSelect" id="styledSelect" name="country">
                  <option value="Deutschland">Deutschland</option>
                  <option value="Österreich">Österreich</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Belgien">Belgien</option>
                  <option value="Italien">Italien</option>
                  <option value="Schweiz">Schweiz</option>
                  <option value="Luxemburg">Luxemburg</option>
                  <option value="Dänemark">Dänemark</option>
                  <option value="Polen">Polen</option>
                  <option value="Frankreich">Frankreich</option>
                  <option value="England">England</option>
                </select>

                {this.props.match.params.role === 'non_commercial' &&
                 <div className="Reg_checkbox">
                   <label clasName="Reg_checkbox_label" htmlFor="non_commercial_confirm">
                     <input name="non_commercial_confirm" type="checkbox" value={this.state.non_commercial_confirm} onChange={event => this.setState({non_commercial_confirm: event.target.checked})} />
                     Ich oder meine Organisation leben nicht PRIMÄR vom Handel mit Produkten
                   </label>
                 </div>}

              </div>
              {/* TODO only for logged in Users*/}

              <div className="marginTop30">
                <div className="buttonDiv">
                  <div className="button" onClick={ this.onSubmit} > Registrieren </div>
                </div>
              </div>
              <div className="marginTop30">
                <div className="buttonDiv">
                  <div className="button"> Bereits Registriert? Zum Login </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer faqs={faqReg} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/registration.js